export const SPACE = {
  HAIR: ' ',
  THIN: ' ',
  NBSP: ' ',
  NNBSP: ' ',
  EN: ' ',
  EM: ' ',
  FIGURE: ' ',
}
